import { Slide } from "./components/slide/slide";
import { Base } from "./slides.base";

export const Slides = Object.assign(Base, {
    Slide: Slide
});
